module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAABU0lEQVRIS+WVPyuFcRTHP19SyjswWRks4g2IVTbZ3DLYSNy8AaSYlDJgMShlYLB4AUpJMViU0QswyJ+vjn5X1+1ej+fRHVy/8feccz7nfM/5nUc0+ajJ8WkxgO0uoAz0A2055XsDroA1SY8V3y8S2T4EhoEzIBzynIg1ApxKmmgEeALmJW3miVyxtT0LrErqbAQwcATMSbrPA7HdA2wA45I+lamVKADPKfB+yub2O5Dt3tS3yWTXkQWYAQK0AERWUdGypMtqkO0BYCkyBu6iuUA7sJUFKEnatR3G0awI0hfNA1bSdMXdKHAdVQIHkl5tTwE7PwJUNS5kHEugoXR/HlUBx5Ki2o9TCFAjy2DEkXRRry+/BmRN1f8APAAnwGKBVRG7az2mS1J3o5dcArbTPGdJXu/7CzAtaa8uII1aPK6Y+yLb9KZ2xbTYD6eI6Fk+f1+idxPWmBmwbcv2AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_visa_countries_mail.png
// module id = Tq0V
// module chunks = 1